import { namespace } from 'vuex-class';
import { IContentLibraryState } from '@/content-library/store/content-library.types';
import { EResourceSortAttribute } from '@/api/resources/types/enum/resource-sort-attribute';
import { ESortOrder } from '@/api/resources/types/enum/sort-order';

export const ContentLibrary = namespace('contentLibrary');

export const state: IContentLibraryState = {
  loading: false,
  loaded: false,
  resources: [],
  totalCount: null,
  payload: {
    limit: 24,
    offset: 0,
    filter: {
      directory: '/',
      sortBy: EResourceSortAttribute.UpdatedAt,
      type: null,
      searchTerms: [],
      sortOrder: ESortOrder.Desc,
    },
  },
};

export enum EContentLibraryAction {
  RemoveResource = 'removeResource',
  UpdateResource = 'updateResource',
  Load = 'load',
  LoadSuccess = 'loadSuccess',
  LoadFailed = 'loadFailed',
  LoadMore = 'loadMore',
  LoadMoreSuccess = 'loadMoreSuccess',
  LoadMoreFailed = 'loadMoreFailed',
  LoadThumbnail = 'loadThumbnail',
  LoadThumbnailSuccess = 'loadThumbnailSuccess',
  LoadDetails = 'loadDetails',
  LoadDetailsSuccess = 'loadDetailsSuccess',
  Reset = 'reset',
  UpdateFilter = 'updateFilter',
  ImplementResourceInDocument = 'implementResourceInDocument',
  ImplementResourceInDocumentFailed = 'implementResourceInDocumentFailed',
}

export enum EContentLibraryMutation {
  SetLoading = 'setLoading',
  SetLoaded = 'setLoaded',
  SetResources = 'setResources',
  SetTotalCount = 'setTotalCount',
  SetState = 'setState',
  SetPagination = 'setPagination',
  SetFilter = 'setFilter',
}

export enum EContentLibraryGetter {
  AllResourcesLoaded = 'allResourcesLoaded',
  FilterActive = 'filterActive',
}
